module.exports = __webpack_public_path__ + "static/_0002_LOVENI-d44562512c8d737d9e6aa89efc6dcf9d.jpg";